<template>
    <div
        id="anchor-logo"
        class="main-container">
        <div
            class="logo-section">
            <div class="logo-title-container">
                <div class="logo-title">
                    <h2>{{ $t("press.logoSection.logo").toUpperCase() }}</h2>
                </div>
                <div class="logo-description">
                    <p>{{ $t("press.logoSection.textLogo") }}</p>
                </div>
            </div>
            <div class="logo-grid">
                <div
                    v-for="(logo, index) in logos"
                    :key="index"
                    class="logo-cell">
                    <div
                        :class="[
                            'logo-cell-img',
                            logo.backgroundWhite == true
                                ? 'white-background'
                                : 'black-background'
                        ]">
                        <img :src="logo.srcPng" />
                    </div>
                    <p class="logo-text">
                        {{ logo.text }}
                    </p>
                    <div class="logo-download">
                        <p>{{ $t("press.logoSection.download") }}</p>
                        <a
                            :href="logo.srcPng"
                            download>
                            {{ $t("press.logoSection.png") }}
                        </a>
                        <a
                            :href="logo.srcSvg"
                            download>
                            {{ $t("press.logoSection.svg") }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="logo-title-container">
                <div
                    id="alternative"
                    class="logo-title">
                    <h2>{{ $t("press.logoSection.alternativeLogo").toUpperCase() }}</h2>
                </div>
                <div class="logo-description">
                    <p>{{ $t("press.logoSection.textAlternativeLogo") }}</p>
                </div>
            </div>
            <div class="isotype-logo">
                <div class="logo-cell">
                    <div class="logo-cell-img black-background">
                        <img :src="sandboxLogoIsotypePng" />
                    </div>
                    <p class="logo-text">
                        {{ $t("press.logoSection.isotype") }}
                    </p>
                    <div class="logo-download">
                        <p>{{ $t("press.logoSection.download") }}</p>
                        <a
                            target="_blank"
                            :href="sandboxLogoIsotypePng"
                            :download="sandboxLogoIsotypePng">
                            {{ $t("press.logoSection.png") }}
                        </a>
                        <a
                            target="_blank"
                            :href="sandboxLogoIsotypeSvg"
                            :download="sandboxLogoIsotypeSvg">
                            {{ $t("press.logoSection.svg") }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="color-section">
            <h2>{{ $t("press.colorSection.colors").toUpperCase() }}</h2>
            <div class="color-grid-container">
                <div class="color-cell cell_1">
                    <p>{{ $t("press.colorSection.blueTop") }}</p>
                    <p>{{ $t("press.colorSection.blueDown") }}</p>
                </div>
                <div class="color-cell cell_2">
                    <p>{{ $t("press.colorSection.yellowTop") }}</p>
                    <p>{{ $t("press.colorSection.yellowDown") }}</p>
                </div>
                <div class="color-cell cell_3">
                    <p>{{ $t("press.colorSection.greyTop") }}</p>
                    <p>{{ $t("press.colorSection.greyDown") }}</p>
                </div>
                <div class="color-cell cell_4">
                    <p>{{ $t("press.colorSection.greenTop") }}</p>
                    <p>{{ $t("press.colorSection.greenDown") }}</p>
                </div>
                <div class="color-cell cell_5">
                    <p>{{ $t("press.colorSection.redTop") }}</p>
                    <p>{{ $t("press.colorSection.redDown") }}</p>
                </div>
                <div class="color-cell cell_6">
                    <p>{{ $t("press.colorSection.whiteTop") }}</p>
                    <p>{{ $t("press.colorSection.whiteDown") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    computed: {
        pressKitLink () {
            return 'https://presskit.sandbox.game/'
        },
        logosLinkPng () {
            return this.pressKitLink + 'Logos/Png/'
        },
        logosLinkSvg () {
            return this.pressKitLink + 'Logos/Svg/'
        },
        sandboxLogoIsotypePng () {
            return this.logosLinkPng + 'Sandbox_Isotype.png'
        },
        sandboxLogoIsotypeSvg () {
            return this.logosLinkSvg + 'Sandbox_Isotype.svg'
        },
        translate () {
            return {
                logoText: {
                    theSandboxWhite: this.$t('press.logoSection.sandboxWhite'),
                    theSandboxBlack: this.$t('press.logoSection.sandboxBlack'),
                    theSandboxGray: this.$t('press.logoSection.sandboxGray')
                }
            }
        },
        logos () {
            return [
                {
                    srcPng: this.logosLinkPng + 'Sandbox_Logo_White.png',
                    srcSvg: this.logosLinkSvg + 'Sandbox_Logo_White.svg',
                    text: this.translate.logoText.theSandboxWhite,
                    backgroundWhite: false
                },
                {
                    srcPng: this.logosLinkPng + 'Sandbox_Logo_Black.png',
                    srcSvg: this.logosLinkSvg + 'Sandbox_Logo_Black.svg',
                    text: this.translate.logoText.theSandboxBlack,
                    backgroundWhite: true
                },
                {
                    srcPng: this.logosLinkPng + 'Sandbox_Logo_Gray.png',
                    srcSvg: this.logosLinkSvg + 'Sandbox_Logo_Gray.svg',
                    text: this.translate.logoText.theSandboxGray,
                    backgroundWhite: true
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
  .main-container {
    padding: 100px 0px;
    background-color: $gray3;
    @include breakpoint($device: mobile) {
        padding: 80px 0px;
    }
    a {
      text-decoration: none;
      color: $blue-2 !important;
      font-weight: 600;
    }
    p {
        margin-bottom: 0;
    }
    @include breakpoint($min: desktop-sm) {
      & > div:not(:first-child) {
        margin: auto;
        max-width: 75vw;
      }
      & > div:not(:first-child) {
        padding-top: 130px;
      }
    }
    .logo-section {
      @include flex(column, center, center);
      width: 100%;
      .logo-title-container {
        .logo-title {
          @include flex(column, center, center);
          h2 {
            font-size: 50px;
            font-weight: Bold;
          }
        }
        #alternative {
          padding-top: 130px;
        }
        .logo-description {
          max-width: 50vw;
          margin: auto;
          p {
            font-size: 20px;
            text-align: center;
            line-height: 26px;
            max-width: 50vw;
            margin: auto;
            p {
              font-size: 20px;
              text-align: center;
              line-height: 26px;
            }
          }
        }
      }
      .logo-grid {
        display: grid;
        gap: 2em;
        grid-template-columns: repeat(3, minmax(300px, 1fr));
        padding-top: 3vh;
        & > :nth-child(1) {
          justify-self: start;
        }
        & > :nth-child(2) {
          justify-self: center;
        }
        & > :nth-child(3) {
          justify-self: end;
        }
      }
      .isotype-logo {
        @include breakpoint(row, center, center);
        padding-top: 3vh;
      }
      .logo-cell {
        @include flex(column, center, center);
        .logo-cell-img {
          @include flex(row, center, center);
          width: 300px;
          height: 120px;
          background-repeat: no-repeat;
          background-position: 50% 44%;
          border-radius: 10px;
          &.white-background {
            background-image: url("https://presskit.sandbox.game/Logos/Transparent_Backgrounds/Light.png");
          }
          &.black-background {
            background-image: url("https://presskit.sandbox.game/Logos/Transparent_Backgrounds/Dark.png");
          }
          img {
            max-width: 80%;
            max-height: 80%;
          }
        }
        .logo-text {
          margin-top: 15px;
          color: white;
          font-size: 22px;
          font-weight: 800;
          font-family: "Montserrat Bold", sans-serif;
        }
        .logo-download {
          @include flex(row, center, center);
          margin-top: 0px;
          font-weight: 600;
          & > * {
            margin-left: 10px;
            margin-right: 10px;
          }
          p {
            color: gray;
            font-size: 18px;
            font-family: "Montserrat Bold", sans-serif;
          }
          a {
            color: $blue-1;
            font-family: "Montserrat Bold", sans-serif;
          }
        }
      }
    }
    .color-section {
      @include flex(column, center, center);
      width: 100%;
      h2 {
        font-size: 50px;
        font-weight: Bold;
      }
      .color-grid-container {
        display: grid;
        grid-template-columns: repeat(6, minmax(100px, 1fr));
        gap: 20px;
        margin-top: 3vh;
        & > div > p:first-child {
          margin-top: 109px;
        }
        .color-cell {
          width: 150px;
          height: 160px;
          border-radius: 10px;
          box-shadow: 0px 3px 15px #2727274d;
          justify-self: center;
          align-self: center;
          box-shadow: -1rem 0 3rem #000;
          transition: 0.2s;
          text-align: left;
          &:hover {
            transform: translateY(-10px);
          }
          &:hover ~ .color-cell {
            transform: translateX(20px);
          }
          p {
            color: white;
            opacity: 0.9;
            font-size: 14px;
            margin-left: 10px;
          }
        }
        .cell_1 {
          background-color: #0084ff;
          p:hover {
            background: linear-gradient(90deg, #ff8a00, #e52e71);
            text-shadow: none;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .cell_2 {
          background-color: #e5c64a;
          p:hover {
            background: linear-gradient(90deg, #ff8a00, #e52e71);
            text-shadow: none;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .cell_3 {
          background-color: #a0a4a7;
          p:hover {
            background: linear-gradient(90deg, #b012e0, #000);
            text-shadow: none;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .cell_4 {
          background-color: #04c940;
          p:hover {
            background: linear-gradient(90deg, #b012e0, #000);
            text-shadow: none;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .cell_5 {
          background-color: #dd4656;
          p:hover {
            background: linear-gradient(90deg, #e5c64a, #ff8a00);
            text-shadow: none;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .cell_6 {
          background-color: #ffffff;
          p {
            color: black;
          }
          p:hover {
            background: linear-gradient(90deg, #ff8a00, #e52e71);
            text-shadow: none;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }
@include breakpoint($device: touch) {
  .main-container {
    scroll-behavior: smooth;
    .logo-section {
      @include flex(column, center, center);
      width: 100%;
      .logo-title-container {
        .logo-title {
          @include flex(column, center, center);
          h2 {
            font-size: 25px;
            font-weight: Bold;
          }
        }
        .logo-description {
          margin: auto;
          p {
            font-size: 14px;
            text-align: center;
            line-height: 16px;
            max-width: 70vw;
            padding-bottom: 15px;
          }
          @include breakpoint($device: tablet) {
            max-width: 40vw;
          }
          @include breakpoint($device: mobile) {
            max-width: 90vw;
          }
        }
      }
      .logo-grid {
        display: grid;
        grid-gap: 2em;
        grid-template-columns: repeat(1, minmax(330px, 1fr));
        margin-top: 2vh;
        margin-right: 20px;
        margin-left: 20px;
      }
      .logo-cell {
        .logo-cell-img {
          @include flex(row, center, center);
          width: 330px;
          height: 127px;
          background-repeat: no-repeat;
          background-position: 50% 44%;
          border-radius: 10px;
          &.white-background {
            background-image: url("https://presskit.sandbox.game/Logos/Transparent_Backgrounds/Light.png");
          }
          &.black-background {
            background-image: url("https://presskit.sandbox.game/Logos/Transparent_Backgrounds/Dark.png");
          }
          img {
            max-width: 80%;
            max-height: 80%;
          }
        }
        .logo-text {
          margin-top: 15px;
          text-align: left;
          width: 100%;
          margin-left: 20px;
          color: white;
          font: normal normal bold 22px Montserrat;
        }
        .logo-download {
          display: grid;
          grid-gap: 0.5em;
          grid-template-columns: repeat(3, minmax(50px, 1fr));
          & > * {
            justify-self: start;
            align-self: center;
          }
          p {
            color: gray;
            font-size: 18px;
            font-family: "Montserrat Bold", sans-serif;
          }
          a {
            color: $blue-1;
            font-family: "Montserrat Bold", sans-serif;
          }
        }
      }
      #alternative {
        & > div {
          max-width: 200px;
        }
      }
    }
    .color-section {
      @include flex(column, center, center);
      margin-top: 130px;
      width: 100%;
      & > div {
        margin-right: 20px;
        margin-left: 20px;
      }
      h2 {
        font-size: 25px;
        font-weight: Bold;
      }
      .color-grid-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(150px, 1fr));
        gap: 20px;
        margin-top: 25px;
        & > div {
          width: 150px;
          height: 160px;
          border-radius: 10px;
          box-shadow: 0px 3px 15px #2727274d;
          justify-self: center;
          align-self: center;
        }
        & > div > p {
          color: white;
          opacity: 0.9;
          font-size: 14px;
          margin-left: 10px;
        }
        & > div > p:first-child {
          margin-top: 109px;
        }
        .color-cell-1 {
          background-color: #0084ff;
        }
        .color-cell-2 {
          background-color: #e5c64a;
        }
        .color-cell-3 {
          background-color: #a0a4a7;
        }
        .color-cell-4 {
          background-color: #04c940;
        }
        .color-cell-5 {
          background-color: #dd4656;
        }
        .color-cell-6 {
          background-color: #ffffff;
          p {
            color: black;
          }
        }
      }
    }
  }
}
</style>
